import lrp from '@/HOC/lrp';
import withI18n from '@/HOC/withI18n';
import i18n from '@/client/i18n/nl-NL';
import { NextPage } from 'next';

export default withI18n(lrp as unknown as NextPage, i18n);
